import { styled } from '@mui/material/styles';
import { getDrugTestThemeTokens } from '../themeTokens';
import type { DrugTestStatusAlertKind } from '../types';

export const AlertRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'kind',
})<{ kind: DrugTestStatusAlertKind }>(({ theme, kind }) => {
  const t = getDrugTestThemeTokens(theme);
  const variants: Record<DrugTestStatusAlertKind, { background: string; border: string; color: string }> = {
    scheduling_error: {
      background: t.errorBg,
      border: `1px solid ${t.errorBorder}`,
      color: t.errorText,
    },
    withdrawn: {
      background: t.warningBg,
      border: `1px solid ${t.warningBorder}`,
      color: t.warningText,
    },
  };

  return {
    display: 'flex',
    gap: 12,
    padding: '12px 16px',
    borderRadius: 8,
    fontSize: 13,
    margin: '0 0 20px',
    lineHeight: 1.5,
    ...variants[kind],
  };
});

export const AlertIcon = styled('span')({
  fontSize: 18,
  lineHeight: 1.2,
  flexShrink: 0,
});

export const AlertBody = styled('div')({
  minWidth: 0,
});

export const AlertTitle = styled('strong')({
  fontWeight: 700,
});

export const AlertNote = styled('div')(({ theme }) => {
  const t = getDrugTestThemeTokens(theme);
  return {
    marginTop: 10,
    padding: '10px 14px',
    borderRadius: 8,
    fontSize: 12,
    background: t.noteBg,
    border: `1px solid ${t.border}`,
    color: t.textMuted,
  };
});

export const Mono = styled('span')({
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  fontSize: '0.92em',
});
